import { compose } from 'recompose';

import TabPaneView from './TabPaneView';

export default compose()(TabPaneView);
